import { useEssentialsTabCards } from './use-tab-cards';
import { useUserData } from './use-profile';
import { useIsMoveUPO } from 'hooks/useIsMoveUPO';
import { InitiatePayload } from '../types/cards';

export interface ProgressBarData {
  showProgressBar: boolean;
  priorityCards: InitiatePayload[];
  completedCards: InitiatePayload[];
  validatingCards: InitiatePayload[];
  currentMoveDate: string | null | undefined;
  loading: boolean;
}

/**
 * Custom hook that provides all the data needed for the ProgressBarCard component.
 * This centralizes the logic for determining when to show the progress bar and
 * provides the necessary data in a consistent format.
 *
 * @returns ProgressBarData object containing all necessary props for ProgressBarCard
 */
export const useProgressBarData = (): ProgressBarData => {
  // Data fetching hooks
  const {
    priorityCards = [],
    completedCards = [],
    validatingCards: essentialsValidatingCards = [],
    loading: cardsLoading,
  } = useEssentialsTabCards();
  const { user, loading: userLoading } = useUserData();
  const { loading: isMoveUPOLoading, data: { isUPO = false } = {} } =
    useIsMoveUPO();

  // Calculate loading state
  const loading = cardsLoading || userLoading || isMoveUPOLoading;

  const showProgressBar = !!isUPO && !loading;

  return {
    showProgressBar,
    priorityCards: priorityCards as InitiatePayload[],
    completedCards: completedCards as InitiatePayload[],
    validatingCards: essentialsValidatingCards as InitiatePayload[],
    currentMoveDate: user?.currentMove?.date,
    loading,
  };
};
